import OverflowTooltip from '@components/OverflowTooltip/OverflowTooltip';
import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

export interface IBreadcrumbItem {
    name: string;
    folderId: string | null;
}

interface FolderBreadcrumbsProps {
    items: IBreadcrumbItem[];
    onItemClick: (folderId: string | null) => void;
}

const FolderBreadcrumbs = ({ items, onItemClick }: FolderBreadcrumbsProps) => {
    return (
        <ul aria-label="breadcrumb" className="flex items-center">
            {items.map((row, i) => (
                <li
                    key={i}
                    className={twMerge(
                        'flex items-center overflow-hidden text-sm ',
                        i === items.length - 1
                            ? 'text-grayscale-900 font-semibold after:hidden'
                            : "text-grayscale-500 after:mx-2 after:text-xs after:font-medium after:text-grayscale-400 after:content-['/']"
                    )}
                >
                    {i < items.length - 1 ? (
                        <button
                            className="cursor-pointer hover:underline overflow-hidden"
                            onClick={() => onItemClick(row.folderId)}
                        >
                            <OverflowTooltip>{row.name}</OverflowTooltip>
                        </button>
                    ) : (
                        <OverflowTooltip>{row.name}</OverflowTooltip>
                    )}
                </li>
            ))}
        </ul>
    );
};

export default FolderBreadcrumbs;
